import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors";
import featuredIcon from "../../../../resources/images/preview-icon.svg";
import trashIcon from "../../../../resources/images/delete-icon.svg";
import externalIcon from "../../../../resources/images/link-external.svg";
import checkIconRed from "../../../../resources/images/alert-circle.svg";

const styles = createUseStyles({
  editCompany: {
    margin: "4px 0 0 0",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px 0px",
    }
  },
  details: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "32px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "flex",
      alignItems: "flex-start"
    }
  },
  pContactSubtext: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    marginTop: "3px",
    marginBottom: "0px"
  },
  btnContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  title: {
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom: "4px",
    color: colors.lightBlack,
  },
  description: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
  },
  buttonCancel: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight: "12px",
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px"
  },
  formCont: {
    marginTop: "4px",
    "& .row": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        display: "grid",
      }
    },
    "& .col-md-4": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        marginBottom: "32px"
      }
    },
  },
  location: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  formContainer: {
    width: "512px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "462px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    }
  },
  inputContainer: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    "& input": {
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      "&:focus": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "default",
        backgroundColor: "rgba(239, 239, 239, 0.3)",
        color: "rgb(84, 84, 84)",
        borderColor: "rgba(118, 118, 118, 0.3)",
      },
    },
    "& .input-error": {
      border: "1px solid " + colors.red,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      backgroundImage: `url(${checkIconRed})`
    },
  },
  lastInputContainer: {
    marginBottom: "0px",
  },
  refferalInputContainer: {
    marginBottom: "4px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey,
    marginBottom: "6px"
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },

  emailExampleContainer: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.mediumGrey,
    marginTop: "-14px"
  },
  containerPlace: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
      gap: "0px",
    },

  },
  preview: {
    display: "flex",
    alignItems: "center",
    width: "512px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "300px",
    },
    marginBottom: "32px",
  },
  fileIcon: {
    backgroundPosition: "center",
    backgroundSize: "40px 40px",
    backgroundRepeat: "no-repeat",
    width: "59px",
    height: "40px",
    backgroundImage: `url(${featuredIcon})`
  },
  wrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginLeft: "12px"
  },
  documentTitle: {
    fontSize: "14px",
    color: colors.lightBlack,
    fontWeight: "500",
  },
  icon: {
    marginRight: "30px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginRight: "5px",
    },
    backgroundSize: "20px 20px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "25px",
    height: "25px",
    backgroundImage: `url(${trashIcon})`
  },
  externalIcon: {
    marginRight: "30px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginRight: "5px",
    },
    backgroundSize: "20px 20px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "25px",
    height: "25px",
    backgroundImage: `url(${externalIcon})`
  },
  iconWrapper: {
    display: "flex",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "30px"
  },
  roles: {
    textAlign: "left",
    height: "44px",
  },
  button: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
  },
  deleteCompanyButton: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content"
  },
  warningIconContainer: {
    width: "auto",
    minWidth: "fit-content",
    paddingRight: "0px",
    display: "inline-block"
  },
  accountClosedTitle: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px"
  },
  accountClosedDescription: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px"
  },
  removeBtnContainer: {
    height: "42px",
    display: "flex",
    alignItems: "center"
  },
  removeInput: {
    padding: "0 0 0 5px"
  },
  phoneInputContainer: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    "& input": {
      height: "44px",
      width: "100%",
      borderWidth: "0px",
      borderRadius: "0px 8px 8px 0px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& .input-error": {
      border: "1px solid " + colors.red,
      borderRadius: "8px",
      "& input": {
        backgroundSize: "16px 16px",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        backgroundOrigin: "content-box",
        backgroundImage: `url(${checkIconRed})`
      },
    },
  },
  inputGroupWrapper: {
    flexWrap: "nowrap",
  },
  adminLabel: {
    display: "inline-flex",
    gap: "8px"
  },
  adminName: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "24px",
    color: colors.lightBlack
  },
  adminEmail: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    color: colors.mediumGrey
  },
  optional: {
    display: "inline",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
    color: colors.inactiveGrey,
    margin: "auto 0px auto 6px"
  },
  taxExampleContainer: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.mediumGrey,
    marginTop: "-14px",
    marginBottom: "20px"
  },
  taxIdNote: {
    color: colors.mediumGrey,
    fontSize: "14px",
  },
  cargoCheckbox: {
    marginTop: "20px"
  },
  labelClass: {
    marginTop: "20px",
    marginLeft: "8px"
  },
  thrDescription: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: colors.mediumGrey,
  },
  thrTitle: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  statusDiv: {
    display: 'flex',
    alignItems: "center",
    "& svg": {
      width: "32px",
      height: '32px'
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "15px"
    }
  },
  textDiv: {
    marginLeft: "12px"
  },
  colContentWrapper: {
    display: 'flex'
  },
  thresholdStatusBtn: {
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.primary700Blue,
    alignSelf: "center",
    marginLeft: '14px'
  },
  inputMailContainer: {
    display: "flex",
    flexDirection: "column",
  },
  editButton: {
    padding: "8px 12px",
    width: "44px",
    height: "42px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius: "0px 8px 8px 0px",
    backgroundColor: colors.white,
    display: "flex",
    alignItems: "center",
    "& span": {
      marginLeft: "0px",
      display: "flex"
    },
    "& svg": {
      width: "20px",
      height: "20px",
    },
    "&[class*='disabled']": {
      backgroundColor: `${colors.brightBlue} !important`,
      borderRight: `none !important`,
      borderTop: `none !important`,
      borderBottom: `none !important`,
      borderLeft: `"1px solid " + ${colors.darkGrey} !important`,
      pointerEvents: "none",
    },
    "&:disabled": {
      backgroundColor: colors.brightBlue,
    }
  },
  editDiv: {
    justifyContent: "space-between",
    display: "flex",
    backgroundColor: colors.brightBlue,
    border: "1px solid " + colors.darkGrey,
    height: "44px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    "& input": {
      border: "none",
      marginLeft: "10px",
      padding: "0px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]": {
      width: "-webkit-fill-available",
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  tooltip: {
    "& .tooltip-inner": {
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign: "start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none",
    },
  },
  infoIcon: {
    cursor: "pointer"
  },
  infoDescription: {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
    "& ul": {
      margin: "0px",
      paddingLeft: "18px"
    },
  },
  preferenceLabel: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: colors.grey,
    marginBottom: "6px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& a": {
      textDecoration: "none",
      color: colors.darkBlue,
    },
  },
  citiPcanDiv: {
    marginBottom: "16px"
  },
  secondRowAuto: {
    display: "flex",
    marginLeft: "auto",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: "0",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "flex"
    },
  },
  longSk: {
    paddingBottom: "8px",
    marginBottom: "20px",
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "68px !important",
    },
  },
  longSkM: {
    extend: "longSk",
    marginRight: "12px"
  },
  contractDetailsLink: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    color: colors.hoverAS,
    marginTop: "6px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none"
    }
  },
      errorContentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    borderRadius: "8px",
    marginTop: "20px",
  },
  errorTitle: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    marginBottom: "8px",
    color: colors.lightBlack,
  },
  errorText: {
    fontSize: "14px",
    textAlign: "center",
  },
  closeButton: {
    fontWeight: "600",  
    fontSize: "14px",
    lineHeight: "20px",
    marginLeft: "12px",
  }
});

export default styles;

export const countrySelect = {
  option: (base, state) => {
    const displayBorder = () => {
      return state.data.value &&
        state.options?.length > 2 &&
        state.data.value === 'CA' &&
        !state?.selectProps?.inputValue
    }
    return {
      ...base,
      'img': {
        display: state.isSelected ? 'inline' : 'none',
        float: "right",
        marginTop: "2px"
      },
      backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        backgroundColor: colors.brightBlue
      },
      "&.disabled": {
        background: colors.lightGrey
      },
      position: 'relative',
      "&::after": {
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        borderBottom: displayBorder() ? "1px solid " + colors.lightGrey : "0px transparent",
      }
    }
  },
}

export const selectError = {
  control: (base, state, errors) => ({
    ...base,
    borderRadius: "8px",
    border: "1px solid " + colors.red,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      minHeight: "50px",
    },
  }),
  valueContainer: base => ({
    ...base,
    padding: "0px 1px 0px 14px"
  }),
};